import React from 'react';
import './SearchHit.scss';

export default function ({ hit, lang }) {
  const { REACT_APP_TABLES_BASEURL } = process.env;

  const { id, number, translations } = hit.data;
  const { title, refPeriodStart, refPeriodEnd } = translations[lang];
  const { highlight } = hit;
  const highlightHTML =
    (lang === 'en' ? highlight.contentEn : highlight.content) ||
    (lang === 'en' ? highlight.leadEn : highlight.lead);

  const url = `${REACT_APP_TABLES_BASEURL}/${id.substr(0, 3)}/${lang}/${id}.html`;

  const titleHTML = (lang === 'en' ? highlight.titleEn : highlight.title) ||
    (number + ' ' + title + ' (' + refPeriodStart + '–' + refPeriodEnd + ')');

  return (
    <div className="search-hit">
      <div className="title"><a href={url} dangerouslySetInnerHTML={{ __html: titleHTML }}></a></div>
      <div className="access-url">
        <a href={url}>{url}</a>
      </div>
      <div className="highlight" dangerouslySetInnerHTML={{ __html: highlightHTML }}></div>
    </div>
  );
};
